<div class="publish-screen">
  <div class="row">
    <div class="col-md-12 publish-top-line">
      <div class="publish-buttons col-md-6 float-left">
          <a [routerLink]="['/']" class="btn btn-secondary back"><i class="fa fa-angle-double-left"></i> Back to list</a>
          <a [routerLink]="['/storyboard', storyboardId]" class="btn btn-secondary back"><i class="fa fa-angle-left"></i> Back to edit</a>
        </div>
        <div class="publish-buttons col-md-6 float-right">
            <button class="btn btn-primary download" [disabled]="storyboardLoading || rendering || !success" (click)="downloadVideo()"><i class="fa fa-download"></i> Video</button>
            <button class="btn btn-primary download-dab"
                    *ngIf="showGenerateDab && !renderingDab"
                    [disabled]="disableGenerateDabButton || rendering"
                    (click)="generateDAB()"><i class="fa fa-ellipsis-h"></i> Generate DAB</button>

            <button class="btn btn-primary download-dab"
                    *ngIf="renderingDab"
                    [disabled]="true"><i class="fa fa-refresh fa-spin"></i> DAB generation in progress</button>

            <button
                    class="btn btn-primary download-dab"
                    *ngIf="!showGenerateDab && !renderingDab"
                    [disabled]="storyboardLoading || rendering"
                    (click)="downloadDAB()"><i class="fa fa-download"></i> DAB</button>
          </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 publish-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12 publish-title" *ngIf="storyboard">
            <span class="publishing">Publishing: </span> {{ storyboard.title }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="storyboardLoading">
    <div class="col-md-12">
      <div class="spinner-bar"></div>
    </div>
  </div>

  <div class="row" *ngIf="!storyboardLoading">
    <div class="col-md-12">
      <div class="video-player" *ngIf="!rendering && success && storyboard.last_video_export.sources.length">
        <vg-player>
          <vg-controls [vgFor]="video-player" [vgAutohide]="true" [vgAutohideTime]="5">
            <vg-play-pause [vgFor]="video-player"></vg-play-pause>
            <vg-scrub-bar [vgFor]="video-player" [vgSlider]="false">
              <vg-scrub-bar-current-time [vgFor]="video-player" [vgSlider]="true"></vg-scrub-bar-current-time>
              <vg-scrub-bar-buffering-time [vgFor]="video-player"></vg-scrub-bar-buffering-time>
            </vg-scrub-bar>
            <vg-time-display [vgFor]="video-player" [vgProperty]="'current'" [vgFormat]="'mm:ss'"></vg-time-display>
            <vg-mute [vgFor]="video-player"></vg-mute>
            <vg-volume [vgFor]="video-player"></vg-volume>
            <vg-fullscreen></vg-fullscreen>
          </vg-controls>
          <video [vgMedia]="media" #media id="video-player" preload="auto">
            <source [src]="storyboard.last_video_export.sources[0].url" type="video/mp4">
          </video>
        </vg-player>
      </div>

      <!--<div class="rendering" *ngIf="rendering || !success">-->
        <!--<div class="rendering-line">-->
          <!--<div class="rendering-status"></div>-->
        <!--</div>-->
        <!--<div class="btn render-info" *ngIf="success">-->
          <!--<div class="spinner-bar"></div>-->
          <!--We're now making your video. Feel free to exit this screen / go make a coffee. You'll know that your video is ready when you see a proper thumbnail on the Storyboard list page.-->
        <!--</div>-->

        <!--<div class="btn render-error" *ngIf="!success || !dabSuccess">-->
          <!--Something went wrong, please try the rendering later.-->
        <!--</div>-->
      <!--</div>-->
      <div class="video-rendering-status">
        <div class="in-queue-more-three" *ngIf="mode === MODES.MORE_THEN_ONE_IN_QUEUE">
          <div class="image-clock-wrapper">
            <img src="../../assets/images/ic_clock_grey.png" alt="grey_clock">
          </div>
          <div class="first-step-notice">
            {{'There are some other videos are getting rendered at the moment, you are the '}}
            {{numberInQueue}}{{' in the queue'}}
          </div>
        </div>

        <div class="in-queue-one" *ngIf="mode === MODES.ONE_IN_QUEUE">
          <div class="image-clock-wrapper">
            <img src="../../assets/images/ic_clock_grey.png" alt="grey_clock">
          </div>
          <div class="second-step-notice">
            {{'There is only one video ahead of you to be rendered, you\'re next!'}}
          </div>
        </div>

        <div class="in-queue-one" *ngIf="mode === MODES.STARTING_UP">
          <div class="image-clock-wrapper">
            <img src="../../assets/images/ic_clock_grey.png" alt="grey_clock">
          </div>
          <div class="second-step-notice">
            {{'Starting up render job, delegating rendering machines. This takes around 30 seconds.'}}
          </div>
        </div>

        <div class="progress-first-step" *ngIf="mode === MODES.LESS_25_PERCENTS">
          <div class="image-clock-wrapper">
            <img src="../../assets/images/ic_clock_orange.png" alt="orange_clock">
          </div>
          <div class="progress-first-step-notice">
            {{'Currently rendering frame'}}
          </div>
          <div class="frame-info-first">
            <span class="render-completed-frames">{{framesDone}}</span> {{'out of'}} <span>{{amountOfFrames}}</span>
          </div>
        </div>

        <div class="progress-second-step" *ngIf="mode === MODES.BETWEEN_25_90_PERCENTS">
          <div class="image-clock-wrapper">
            <img src="../../assets/images/ic_clock_blue.png" alt="blue_clock">
          </div>
          <div class="progress-second-step-notice">
            {{'Currently rendering frame'}}
          </div>
          <div class="frame-info-second">
            <span class="render-completed-frames">{{framesDone}}</span> {{'out of'}} <span>{{amountOfFrames}}</span>
          </div>
        </div>

        <div class="progress-third-step" *ngIf="mode === MODES.FINALIZING">
          <div class="image-clock-wrapper">
            <img src="../../assets/images/ic_clock_green.png" alt="green_clock">
          </div>
          <div class="progress-third-step-notice">
            {{'Your video will be ready in a few seconds...'}}
          </div>
        </div>

        <div class="progress-bar-wrapper" *ngIf="(mode === MODES.LESS_25_PERCENTS) || (mode === MODES.BETWEEN_25_90_PERCENTS)">
          <app-storyboard-progress-bar [progressWidth]="progress"></app-storyboard-progress-bar>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard-publish/storyboard-publish.component.html